<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Blockquote-First">“A child, more than all other gifts </p>
<p class="ORIM-Blockquote-Body">That earth can offer to declining man, </p>
<p class="ORIM-Blockquote-Body">Brings hope with it, and forward-looking thoughts.” </p>
<p class="ORIM-Blockquote-Body">—WORDSWORTH.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled11.vue?01cab7c2